import { render, staticRenderFns } from "./GiftBoxCampaignsFeedbackModal.vue?vue&type=template&id=1a1d3cc0&scoped=true&"
import script from "./GiftBoxCampaignsFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d3cc0",
  null
  
)

export default component.exports